export class State{

    constructor(manager){

        this.manager = manager;

        this.readyForChangeState = false;

    }
    
    Animate(deltaTime){}

    Enter(){}

    Exit(){}

    Pause(){}

    Resume(){}
}